import i18n from '@/plugins/vue-i18n'
function upload (formData) {
  const files = formData.getAll(Array.from(formData.keys())[0])
  const promises = files.map((x) => getFile(x)
    .then(file => {
      let extension = x.name.split('.').pop()
      let nombre = x.name
      if (nombre.length > 100) {
        let longitudExtension = !extension ? 0 : (extension.length)
        nombre = nombre.substring(0, 100 - (longitudExtension + 1))
        if (extension) {
          nombre += '.' + extension
        }
      }
      return {
        nombre: nombre,
        mime: x.type,
        extension: extension,
        documentoGrande: file.documentoGrande,
        tamanio: x.size
      }
    }))
  return Promise.all(promises)
}

function getFile (file) {
  return new Promise((resolve, reject) => {
    if (!file.type) {
      reject(new Error(i18n.t('general.filePreviewUpload.errorTipo', {nombre: file.name})))
    } else if (!file.size > 10485760) {
      reject(new Error(i18n.t('general.filePreviewUpload.errorSize', {nombre: file.name})))
    } else {
      const fReader = new FileReader()
      fReader.onload = () => {
        resolve({
          documentoGrande: fReader.result
        })
      }
      fReader.readAsDataURL(file)
    }
  })
}

export { upload }



// WEBPACK FOOTER //
// ./src/components/generic/fileUploader/filePreviewUpload.js